export const SOIL_TYPE = {
  SANDY: 'SANDY',
  NORMAL: 'NORMAL',
  HEAVY_CLAY: 'HEAVY_CLAY',
  HUMIC: 'HUMIC',
};

export type SoilType = (typeof SOIL_TYPE)[keyof typeof SOIL_TYPE];

export const allSoilTypes = () => {
  return [SOIL_TYPE.SANDY, SOIL_TYPE.NORMAL, SOIL_TYPE.HEAVY_CLAY, SOIL_TYPE.HUMIC];
};
